import React from 'react';
import { FolderOpen } from 'lucide-react';
import {
  TenderBauvorhabenPanel,
  TenderDocumentsListPanel,
  type TenderBasisCustomerEditProps,
} from './TenderBasisInfoCard';
import type { AusschreibungDetail, TenderDocument } from '../types';

interface Props {
  ausschreibung: AusschreibungDetail;
  documents: TenderDocument[];
  onUploaded: (doc: TenderDocument) => void;
  onDeleted: (docId: string) => void;
  customerEdit?: TenderBasisCustomerEditProps;
}

/** Linke Spalte der Akte: Bauvorhaben oben, Dokumente darunter in einem Tab. */
export const TenderReviewLeftRail: React.FC<Props> = ({
  ausschreibung,
  documents,
  onUploaded,
  onDeleted,
  customerEdit,
}) => (
  <div className="h-full min-h-0 max-h-full flex flex-col rounded-lg border border-app-border bg-app-surface shadow-sm overflow-hidden">
    <nav
      className="shrink-0 flex border-b border-app-border bg-app-surface-muted/80"
      aria-label="Bereiche Ausschreibung"
    >
      <span className="flex-1 min-w-0 flex items-center justify-center gap-1.5 py-2.5 px-2 text-sm font-medium border-b-2 border-pipedrive-blue text-pipedrive-blue bg-app-surface">
        <FolderOpen className="w-3.5 h-3.5 shrink-0 opacity-90" aria-hidden />
        <span className="truncate leading-tight">Akte</span>
      </span>
    </nav>

    <div className="flex-1 min-h-0 min-w-0 overflow-hidden flex flex-col">
      {/* Bauvorhaben oben (bei langem Formular eigener Scroll), Dokumente füllen den Rest. */}
      <div className="shrink-0 max-h-[55%] min-h-0 flex flex-col border-b border-app-border">
        <TenderBauvorhabenPanel ausschreibung={ausschreibung} customerEdit={customerEdit} />
      </div>
      <div className="flex-1 min-h-0 flex flex-col">
        <TenderDocumentsListPanel
          ausschreibungId={ausschreibung.id}
          documents={documents}
          onUploaded={onUploaded}
          onDeleted={onDeleted}
        />
      </div>
    </div>
  </div>
);
